import { useNavigate } from 'react-router-dom'
import { Card, Typography, Button, Form } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useFormik, FormikProvider } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { useAuthStore } from '@/stores/authStore'
import { FormikInput } from '@/components/FormikInput'
import { getApiErrorMessage } from '@/lib/apiError'

const { Title, Text } = Typography

export const TAMANHO_MINIMO_DA_SENHA = 6

const senhaSchema = Yup.object({
  senhaAtual: Yup.string().required('Informe a senha atual'),
  novaSenha: Yup.string()
    .required('Informe a nova senha')
    .min(TAMANHO_MINIMO_DA_SENHA, `Use ao menos ${TAMANHO_MINIMO_DA_SENHA} caracteres`),
  confirmacao: Yup.string()
    .required('Repita a nova senha')
    .oneOf([Yup.ref('novaSenha')], 'As senhas não conferem'),
})

// ─── Entry component ─────────────────────────────────────────────────────────

export function AlterarSenha() {
  return (
    <div className="max-w-md mx-auto space-y-6">
      <CabecalhoDaPagina />
      <FormularioDeSenha />
    </div>
  )
}

// ─── Helper components ────────────────────────────────────────────────────────

function CabecalhoDaPagina() {
  return (
    <div>
      <Title level={4} className="!mb-1">
        <LockOutlined className="mr-2" />
        Editar senha
      </Title>
      <Text type="secondary">
        A senha vale para o seu acesso, não para o parceiro — quem entra com outro CPF tem a sua.
      </Text>
    </div>
  )
}

function FormularioDeSenha() {
  const alterarSenha = useAuthStore((s) => s.alterarSenha)
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: { senhaAtual: '', novaSenha: '', confirmacao: '' },
    validationSchema: senhaSchema,
    onSubmit: async (values, helpers) => {
      try {
        await alterarSenha(values.senhaAtual, values.novaSenha)
        toast.success('Senha alterada.')
        helpers.resetForm()
        navigate('/dashboard')
      } catch (error: unknown) {
        toast.error(getApiErrorMessage(error, 'Erro ao alterar a senha'))
      }
    },
  })

  return (
    <Card>
      <FormikProvider value={formik}>
        <Form layout="vertical" onFinish={() => formik.handleSubmit()}>
          <FormikInput
            name="senhaAtual"
            label="Senha atual"
            type="password"
            size="large"
            autoComplete="current-password"
          />
          <FormikInput
            name="novaSenha"
            label="Nova senha"
            type="password"
            size="large"
            autoComplete="new-password"
            extra={`Ao menos ${TAMANHO_MINIMO_DA_SENHA} caracteres.`}
          />
          <FormikInput
            name="confirmacao"
            label="Repita a nova senha"
            type="password"
            size="large"
            autoComplete="new-password"
          />
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={formik.isSubmitting}
          >
            Salvar nova senha
          </Button>
        </Form>
      </FormikProvider>
    </Card>
  )
}
